import { dynamicLoader } from '~/utils';

export const RateSheetPage = dynamicLoader({
  name: 'RateSheetPage',
  importFunc: () => import('./rate-sheet'),
});